export const name = "ACOSH";
export const summary = `Computes the inverse hyperbolic cosine of \`X\`.`;
export const reference = `
## ACOSH

Computes the inverse hyperbolic cosine of \`X\`.

\`\`\`
ACOSH(X)
\`\`\`

### Description

Computes the inverse hyperbolic cosine of X. Generates an error if X is a value less than 1.

| X | ACOSH(X) |
| --- | --- |
| \`+inf\` | \`+inf\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |
| X \\< 1 | Error |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
